/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import ProductsRubixLW from "partsproducts/ProductsRubixLW.js";
import Products from "parts/ProductsBlog4.js";
import Footer from "parts/Footer";
import ProductSchema from "../utils/ProductsSchema.js";

import { RubixConnectLW, Blog4 } from "../json/ProductsPageData.js";

export default class RubixLWPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header1 />
        <Helmet>
          <title>Rubix Connect LW | Nube iO – LoRaWAN Expansion Module</title>
          <meta
            name="description"
            content="Add LoRaWAN® connectivity to Rubix Compute and manage large-scale sensor deployments across every site, from single buildings to full portfolios."
          />
          <meta
            name="keywords"
            content="LoRaWAN® expansion module, BACnet/Modbus expansion, IoT gateway expansion, building sensor network"
          />
          <link rel="canonical" href="https://nube-io.com/expansionmodules/" />
          <meta
            property="og:title"
            content="Rubix Connect LW | Nube iO – LoRaWAN Expansion Module"
          />
          <meta
            property="og:description"
            content="Add LoRaWAN® connectivity to Rubix Compute and manage large-scale sensor deployments across every site, from single buildings to full portfolios."
          />
          <meta
            property="og:url"
            content="https://nube-io.com/expansionmodules/"
          />
        </Helmet>
        <ProductSchema name="Rubix Connect LW" description="The Rubix Connect LW features a high-performance LoRaWAN® concentrator card seamlessly integrated into a specialised module for use with the Rubix Compute and other IOT systems." imagePath="/assets/images/RubixConnect01.png" />
        <ProductsRubixLW data={RubixConnectLW} />
        <Products data={Blog4} />
        <Footer />
      </>
    );
  }
}
